<template>
  <div>
    <v-row align="center">
      <v-col v-show="!pageLoaded">
        <gg-card>
          <v-card-text>
            <div class="flex justify-center pt-5 pb-5">
              <v-progress-circular indeterminate size="64" color="primary" />
            </div>
          </v-card-text>
        </gg-card>
      </v-col>
      <v-col v-show="pageLoaded">
        <gg-card v-if="isServiceIdAvailable">
          <v-stepper  v-model="step" vertical>
          <v-stepper-step :complete="step > 1" step="1">
            Reason for Cancellation
          </v-stepper-step>
          <v-stepper-content step="1">
            <cancel-reasons
              @step-back="stepBack"
              @offer-accepted="offerAccepted"
              @offer-declined="offerDeclined(2)"
              @no-offer="noOffer(2)"
              @set-comment="setComment"
              @set-additional-question="setAdditionalQuestion"
              @cancel="moveToService"
              @go-to-last-step="moveToStep(3)"
              @page-loaded="pageLoaded = true"
              @cr-opened="crOpened"
            />
          </v-stepper-content>

          <v-stepper-step :complete="step > 2" step="2">
            Additional Information
          </v-stepper-step>
          <v-stepper-content step="2">
            <additional-information
              ref="additionalInfo"
              :additional-question="additionalQuestion"
              @next-step="nextStep"
              @set-comment="setComment"
              @offer-accepted="offerAccepted"
              @offer-declined="offerDeclined(3)" />
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="3">
            Review
          </v-stepper-step>
          <v-stepper-content step="3">
            <cancel-review
              :comment="comment"
              @step-back="stepBack"
              @cr-opened="crOpened"
              @cancel="moveToService"
              @close="moveToService"
            />
          </v-stepper-content>

          <v-stepper-step :complete="step >= 4" step="4">
            Confirmation
          </v-stepper-step>
          <v-stepper-content step="4">
            <cancel-confirmation
              :template="template"
              :cr_escalate="cr_escalate"
              :cr_open="cr_open"
            />
          </v-stepper-content>
        </v-stepper>
        </gg-card>
        <gg-card v-else>
          <v-card-title class="d-block text-left">
            <h3>Cancel Service</h3>
          </v-card-title>
          <v-card-text>
            You may cancel your service by clicking Manage for the service you want to cancel, then clicking the Stop Renewal option.
          </v-card-text>
        </gg-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CancelReview from 'Components/Cancel/CancelReview'
import CancelReasons from 'Components/Cancel/CancelReasons'
import CancelConfirmation from 'Components/Cancel/CancelConfirmation'
import AdditionalInformation from 'Components/Cancel/AdditionalInformation'
import { cancellationTypes } from '@/consts/cancellations'
import { mapGetters } from 'vuex'

const serviceMapping = {
  hosting: 'hosting_cpanel_info',
  domain: 'domain_info',
  addon: 'hosting_addons'
}

export default {
  name: 'CancelView',
  components: {
    CancelReview,
    CancelReasons,
    CancelConfirmation,
    AdditionalInformation,
  },
  data () {
    return {
      step: 1,
      cr_escalate: {},
      cr_open: {},
      template: '',
      comment: {
        required: false,
        question: ''
      },
      additionalQuestion: '',
      pageLoaded: false
    }
  },
  computed: {
    ...mapGetters(['domains']),
    isServiceIdAvailable () {
      return !!this.$route.params?.service_id
    }
  },
  methods: {
    stepBack () {
      this.step--
    },
    nextStep () {
      this.step++
    },
    offerAccepted (payload) {
      this.template = payload.tpl
      this.step = payload.step
      this.cr_escalate = payload.response
    },
    moveToStep (step) {
      this.step = step
    },
    offerDeclined (step) {
      this.moveToStep(step)
    },
    noOffer (step) {
      this.moveToStep(step)
    },
    crOpened (payload) {
      this.template = payload.tpl
      this.cr_open = payload.response
      this.step++
    },
    setComment (payload) {
      this.comment = payload
    },
    setAdditionalQuestion (payload) {
      this.additionalQuestion = payload
    },
    moveToService () {
      const serviceType = this.$route.query.type

      if (serviceType === 'domain') {
        this.$router.push({
          name: serviceMapping[serviceType],
          params: {
            domainid: this.$route.params.service_id
          }
        })
      } else if (serviceType === cancellationTypes.ID_PROTECT) {
        this.$router.push({
          name: 'domain_info',
          params: {
            domainid: this.domains.find(domain => domain.idprotect_serviceid == this.$route.params.service_id).id
          }
        })
      } else {
        this.$router.push({
          name: serviceMapping[serviceType],
          params: {
            hostingid: serviceType === 'addon' ? this.$route.query.r_s : this.$route.params.service_id
          }
        })
      }
    }
  },
  watch: {
    step (val) {
      if (val === 2) {
        this.$refs.additionalInfo.loadReasons()
      }
    }
  },
}
</script>
